export enum DomainRole {
  EXPERT = 'Expert',
  FP = 'FP',
  DTC = 'DTC',
  DS = 'Domain Secretary',
  WGS = 'WGS',
}